export const guardianPhone = (student = {}) => (
  student.guardian_whatsapp_number
  || student.guardian_phone_number
  || student.guardian_phone
  || student.parent_phone_number
  || student.parent_phone
  || ''
);

export const guardianName = (student = {}) => (
  student.guardian_full_name
  || student.parent_name
  || ''
);